import { gql } from '@apollo/client';

export const MARKETPLACE_POSTS_CSV = gql`
  query ($locationId: String!) {
    getMarketplacePostsCsv(locationId: $locationId)
  }
`;
